var EntityOverview = (function ($, window) {

    // Global settings
    var config = {
        setParams: false,
        elements: {
            template: '#entity-template',
            search: '#entity-search',
            pagination: '#entity-pagination',
            perPage: '#entity-per-page',
            cards: '.filter-cards'
        },
        $container: $('.filter-cards'),
        $records: $('.filter-records'),
        $boxes: $('.filter-box'),
        $search: $('#entity-search'),
        $map: $('#entity-map')
    };

    var sortOptions = {};

    // FilterJS config
    var filter = {
        stream: {
            data_url: NVVS.apiUrl + '?action=list&entity=' + config.$container.data('entity'),
            batch_size: 600, // number of records fetched per stream
            stream_after: 0.5  // stream every x seconds
        },
        search: {
            ele: config.elements.search, // search inputs
            fields: ['fabrikant_naam', 'gebouw_naam', 'zaal_naam', 'bedrijfsnaam', 'naam', 'plaats', 'adres', 'postcode', 'pakket_naam', 'zorgverzekeraar_naam', 'hsnnummer'], // all possible searchable fields
            start_length: 2 // trigger after x characters
        }
    };

    // Google Maps config
    var maps = {
        map: null,
        markers: {},
        fakeMarkers: [],
        clusterer: null,
        activeWindow: null
    };

    /**
     * Initialize FilterJS
     */
    var init = function () {

        var fjs = FilterJS([], config.elements.cards, {
            template: config.elements.template,
            filter_on_init: true,
            search: filter.search,
            pagination: {
                container: config.elements.pagination,
                visiblePages: 6,
                perPage: {
                    values: [18, 36, 72],
                    container: config.elements.perPage
                }
            },
            order: buildSortOptions('verzekering.zorgverzekeraar_naam.asc'),
            appendToContainer: appendResults,
            filter_types: {between: dateBetweenFilter}
        });

        config.$container.addClass('loading');

        // Configure
        fjs.addCallback('beforeAddRecords', beforeAddRecords);
        fjs.addCallback('afterAddRecords', afterAddRecords);
        fjs.addCallback('afterFilter', debounce(afterFilter, 200));
        fjs.addCallback('shortResult', shortResult);
        fjs.setStreaming(filter.stream);

        // Filters: Global
        fjs.addCriteria({
            field: 'hoofd_bestemming',
            ele: '#bestemming-filters input'
        });

        // Filters: Global
        fjs.addCriteria({
            field: 'provincie',
            ele: '#province-filters input'
        });

        // Filters: Hoortoestel
        fjs.addCriteria({
            field: 'reviews.avg_meetmoment_2',
            ele: '#rating-filters input',
            type: 'range'
        });
        fjs.addCriteria({
            field: 'leverbaar',
            ele: '#leverbaar-filters input',
            selector: ':checked'
        });
        fjs.addCriteria({
            field: 'niet_leverbaar_sinds',
            ele: '#date-filters input',
            type: '.$gte'
        });
        fjs.addCriteria({
            field: 'type',
            ele: '#type-filters input'
        });
        fjs.addCriteria({
            field: 'tech',
            ele: '#tech-filters input'
        });
        fjs.addCriteria({
            field: 'zncategorie',
            ele: '#zncategorie-filters input'
        });
        fjs.addCriteria({
            field: 'waterdichtheid',
            ele: '#waterdichtheid-filters input'
        });
        fjs.addCriteria({
            field: 'stofbestendigheid',
            ele: '#stofbestendigheid-filters input'
        });
        fjs.addCriteria({
            field: 'analoog_digitaal',
            ele: '#function-filters input'
        });

        // Filters: Audiologisch Centrum
        fjs.addCriteria({
            field: 'algemeen',
            ele: '#general-filters input'
        });
        fjs.addCriteria({
            field: 'aanbod',
            ele: '#offers-filters input'
        });
        fjs.addCriteria({
            field: 'specialismen',
            ele: '#speciality-filters input'
        });

        // Filters: Zaal
        fjs.addCriteria({
            field: 'keuring_algemeen_oordeel',
            ele: '#quality-filters input'
        });

        // Filters: Audicien
        fjs.addCriteria({
            field: 'rolstoeltoegankelijk',
            ele: '#wheelchair_accessible-filters input'
        });
        fjs.addCriteria({
            field: 'bezoek_audicien_thuis',
            ele: '#home_visit-filters input'
        });
        fjs.addCriteria({
            field: 'keurmerk',
            ele: '#star_mark-filters input'
        });
        fjs.addCriteria({
            field: 'veldnorm_noah4',
            ele: '#veldnorm_noah4-filters input'
        });
        fjs.addCriteria({
            field: 'protocol_hoorhulpmiddelen_2_0',
            ele: '#protocol_hoorhulpmiddelen_2_0-filters input'
        });
        fjs.addCriteria({
            field: 'speciale_hoortests',
            ele: '#special_tests-filters input'
        });

        // Filters: verzekering
        fjs.addCriteria({
            field: 'soort',
            ele: '#soort-filters input'
        });
        fjs.addCriteria({
            field: 'type',
            ele: '#type-filters input'
        });
        fjs.addCriteria({
            field: 'bruikleen_hoortoestellen',
            ele: '#bruikleen_hoortoestellen-filters input'
        });
        fjs.addCriteria({
            field: 'bijbetalen_toegestaan_hoortoestel_boolean',
            ele: '#bijbetalen_toegestaan_hoortoestel_boolean-filters input'
        });
        fjs.addCriteria({
            field: 'batterijen_vergoed',
            ele: '#batterijen_vergoed-filters input'
        });
        fjs.addCriteria({
            field: 'vervanging_hoortoestel_vergoed_boolean',
            ele: '#vervanging_hoortoestel_vergoed_boolean-filters input'
        });
        fjs.addCriteria({
            field: 'bijbetalen_toegestaan_overige_boolean',
            ele: '#bijbetalen_toegestaan_overige_boolean-filters input'
        });
        fjs.addCriteria({
            field: 'vergoeding_patientenvereniging_boolean',
            ele: '#vergoeding_patientenvereniging_boolean-filters input'
        });
        fjs.addCriteria({
            field: 'gecontracteerde_audiciens',
            ele: '#gecontracteerde_audiciens-filters input'
        });
        fjs.addCriteria({
            field: 'kwaliteit',
            ele: '#kwaliteit-filters input'
        });

        // Filter removal
        $('#filters-remove').click(function () {

            var slider = $('#range-slider');

            if (slider.length) {
                slider[0].noUiSlider.reset();
            }

            config.$boxes.find(':checkbox, :radio').prop('checked', false);
            config.$search.val(null);
            fjs.filter();
        });

        $("#order-filter").on('change', function (e) {
            sortOptions = buildSortOptions($(this).val());

            if (sortOptions !== '') {
                fjs.filter();
            }
        });

        initOverview();
    }

    /**
     * Executes before adding records.
     *
     * @param records
     */
    var beforeAddRecords = function (records) {

        if (!records) {
            return;
        }

        if (maps.map) {
            addMarkers(records, true);
        }

        $.each(records, function (i, record) {
            if (record.hasOwnProperty('reviews')) {
                if (record.reviews.hasOwnProperty('avg_meetmoment_2')) {
                    if (record.reviews.avg_meetmoment_2 === null) {
                        record.reviews.avg_meetmoment_2 = 0.0000;
                    }
                    record.reviews.avg_meetmoment_2 = parseFloat(record.reviews.avg_meetmoment_2);
                }
            }
            if (record.niet_leverbaar_sinds === null) {
                record.niet_leverbaar_sinds = 2000;
            } else {
                var date = new Date(record.niet_leverbaar_sinds);
                record.niet_leverbaar_sinds = date.getFullYear();
            }
        });
    };

    var dateBetweenFilter = function (category_value, value) {

        var range = category_value.split('-');
        var between = value.split('-');

        if (Number(between[0]) <= range[0] && Number(between[1]) >= range[0]) {
            true;
        }
    };

    var afterAddRecords = function (records) {
        //var percent = (this.recordsCount - 250) * 100 / 250;
        //
        //$('#stream_progress').text(percent + '%').attr('style', 'width: ' + percent + '%;');
        //
        //if (percent === 100) {
        //	$('#stream_progress').parent().fadeOut(1000);
        //}
    }

    // Create a new date from a string, return as a timestamp.
    var timestamp = function (str) {
        return new Date(str).getTime();
    };

    /**
     * Executes after each filter event.
     *
     * @param result
     * @param jQ
     */
    var afterFilter = function (result, jQ) {
        config.$records.text(result.length);

        if (maps.map) {
            updateMarkers(result);
        }

        if (config.$container.hasClass('loading')) {
            config.$container.removeClass('loading');
        }
    };

    /**
     * Append results to the container.
     *
     * @param html
     * @param records
     */
    var appendResults = function (html, records) {
        config.$container.append(html);

        $(window).resize();
    };

    /**
     * Set (default) ordering of entities based on selected dropdown.
     *
     * @param query
     */
    var shortResult = function (query) {

        if (Object.keys(sortOptions).length !== 0) {
            query.order(sortOptions);
        } else {
            var selectedOrder = ( $('#order-filter').val());
            query.order(buildSortOptions(selectedOrder));
        }
    };

    var buildSortOptions = function (name) {
        var result = '';

        switch (name) {
            case 'hoortoestel.name.asc':
                result = {'fabrikant_naam': 'asc'};
                break;
            case 'hoortoestel.name.desc':
                result = {'fabrikant_naam': 'desc'};
                break;
            case 'hoortoestel.review.desc':
                result = {'reviews.avg_meetmoment_2_at_least_10': 'desc'};
                break;

            case 'audicien.name.asc':
                result = {'naam': 'asc'};
                break;
            case 'audicien.name.desc':
                result = {'naam': 'desc'};
                break;
            case 'audicien.review.desc':
                result = {'reviews.gemervaringsscore': 'desc'};
                break;

            case 'audiologisch_centrum.name.asc':
                result = {'naam': 'asc'};
                break;
            case 'audiologisch_centrum.name.desc':
                result = {'naam': 'desc'};
                break;
            case 'audiologisch_centrum.review.desc':
                result = {'reviews.avg_geheel_at_least_10': 'desc'};
                break;

            case 'knoafdeling.name.asc':
                result = {'naam': 'asc'};
                break;
            case 'knoafdeling.name.desc':
                result = {'naam': 'desc'};
                break;

            case 'verzekering.zorgverzekeraar_naam.asc':
                result = {'zorgverzekeraar_naam': 'asc'};
                break;
            case 'verzekering.zorgverzekeraar_naam.desc':
                result = {'zorgverzekeraar_naam': 'desc'};
                break;

            case 'zaal.name.asc':
                result = {'gebouw_naam': 'asc'};
                break;
            case 'zaal.name.desc':
                result = {'gebouw_naam': 'desc'};
                break;
        }

        return result;
    };

    /**
     * Initialize the overview's functionality.
     */
    var initOverview = function () {
        // Mobile filters
        config.$boxes.find('h5').click(function () {
            if ($(window).width() < 768) {
                $(this).siblings('.filter-box__content').slideToggle(300);
            }
        });

        // Pagination
        $(config.elements.pagination).on('click', 'a', function (e) {
            window.scrollTo(0, 260);
        });

        // Range slider
        var $rangeSlider      = $('#range-slider'),
            $rangeSliderInput = $rangeSlider.next('input');

        if ($rangeSlider.length) {
            noUiSlider.create($rangeSlider[0], {
                start: [0, 10],
                step: 0.5,
                connect: true,
                range: {
                    'min': 0,
                    'max': 10
                },
                tooltips: [true, wNumb({decimals: 1})],
                format: wNumb({
                    decimals: 1,
                    mark: '.'
                })
            });

            $rangeSlider[0].noUiSlider.on('update', debounce(function (values, handle) {
                $rangeSliderInput.val(values.join('-')).trigger('change');
            }, 200));
        }

        // Date slider
        var $dateSlider      = $('#date-slider'),
            $dateSliderInput = $dateSlider.next('input');

        if ($dateSlider.length) {

            noUiSlider.create($dateSlider[0], {
                // Create two timestamps to define a range.
                range: {
                    min: timestamp('2000'),
                    max: timestamp('2017')
                },
                connect: [true, false],

                // Steps of one year
                step: 365 * 24 * 60 * 60 * 1000,

                // Two more timestamps indicate the handle starting positions.
                start: timestamp('2000'),
                tooltips: true,
                // No decimals
                format: {
                    to: function (value) {
                        return formatDate(new Date(value));
                    },
                    from: function () {
                        return '';
                    }
                }
            });

            $dateSlider[0].noUiSlider.on('update', function (values, handle) {
                $dateSliderInput.val(values[handle]).trigger('change');
            });
        }
    }

    // Create a string representation of the date.
    function formatDate(date) {
        return date.getFullYear();
    }

    /**
     * Initialize Google Maps after mapsLoaded() was called.
     */
    var initMap = function () {
        if (!config.$map.length) {
            return;
        }

        var single = false,
            latLng = {lat: 52.150, lng: 5.291266};

        if (config.$map.data('lat') && config.$map.data('lng')) {
            single = true;
            latLng.lat = config.$map.data('lat');
            latLng.lng = config.$map.data('lng');
        }

        maps.map = new google.maps.Map(config.$map[0], {
            center: latLng,
            zoom: single ? 13 : 6,
            scrollwheel: false,
            draggable: !('ontouchend' in document), // disable on mobile
            styles: [{
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [{"color": "#e9e9e9"}, {"lightness": 17}]
            }, {
                "featureType": "landscape",
                "elementType": "geometry",
                "stylers": [{"color": "#f5f5f5"}, {"lightness": 20}]
            }, {
                "featureType": "road.highway",
                "elementType": "geometry.fill",
                "stylers": [{"color": "#ffffff"}, {"lightness": 17}]
            }, {
                "featureType": "road.highway",
                "elementType": "geometry.stroke",
                "stylers": [{"color": "#ffffff"}, {"lightness": 29}, {"weight": 0.2}]
            }, {
                "featureType": "road.arterial",
                "elementType": "geometry",
                "stylers": [{"color": "#ffffff"}, {"lightness": 18}]
            }, {
                "featureType": "road.local",
                "elementType": "geometry",
                "stylers": [{"color": "#ffffff"}, {"lightness": 16}]
            }, {
                "featureType": "poi",
                "elementType": "geometry",
                "stylers": [{"color": "#f5f5f5"}, {"lightness": 21}]
            }, {
                "featureType": "poi.park",
                "elementType": "geometry",
                "stylers": [{"color": "#dedede"}, {"lightness": 21}]
            }, {
                "elementType": "labels.text.stroke",
                "stylers": [{"visibility": "on"}, {"color": "#ffffff"}, {"lightness": 16}]
            }, {
                "elementType": "labels.text.fill",
                "stylers": [{"saturation": 36}, {"color": "#333333"}, {"lightness": 40}]
            }, {"elementType": "labels.icon", "stylers": [{"visibility": "off"}]}, {
                "featureType": "transit",
                "elementType": "geometry",
                "stylers": [{"color": "#f2f2f2"}, {"lightness": 19}]
            }, {
                "featureType": "administrative",
                "elementType": "geometry.fill",
                "stylers": [{"color": "#fefefe"}, {"lightness": 20}]
            }, {
                "featureType": "administrative",
                "elementType": "geometry.stroke",
                "stylers": [{"color": "#fefefe"}, {"lightness": 17}, {"weight": 1.2}]
            }]
        });

        if (single) {
            addMarkers([{
                adres_latitude: latLng.lat,
                adres_longitude: latLng.lng
            }], false);
        }
    };

    /**
     * Add markers for each record within GMaps.
     *
     * @param records
     * @param showInfoWindow
     */
    var addMarkers = function (records, showInfoWindow) {
        var infoWindow,
            markerIcon = config.$map.data('marker');

        $.each(records, function (i, record) {
            if (!record.hasOwnProperty('adres_latitude') || !record.hasOwnProperty('adres_longitude')) {
                return true; // continue
            }

            record.coords = {
                lat: record.adres_latitude,
                lng: record.adres_longitude
            };

            var marker = new google.maps.Marker({
                icon: {
                    url: markerIcon,
                    scaledSize: new google.maps.Size(24, 34),
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(0, 34)
                },
                map: maps.map,
                position: new google.maps.LatLng(record.coords.lat, record.coords.lng)
            });

            var title = record.hasOwnProperty('gebouw_naam') ? record.gebouw_naam + ' ' + record.zaal_naam : record.naam;

            if (showInfoWindow) {
                var infoWindow = new google.maps.InfoWindow({
                    content: '<strong>' + title + '</strong>' +
                    '<br>' + record.adres + ' ' + record.huisnummer + ' ' + record.huisnummer_toevoeging
                });
            }

            marker.addListener('click', function () {
                if (maps.activeWindow) {
                    maps.activeWindow.close();
                }

                maps.map.setCenter(marker.getPosition());
                maps.map.setZoom(15);

                if (infoWindow) {
                    maps.activeWindow = infoWindow;
                    infoWindow.open(maps.map, marker);
                }
            });

            maps.markers[record.id] = marker;
        });
    };

    /**
     * Update markers depending on the given filter.
     */
    var updateMarkers = function (records) {
        var filteredMarkers       = [],
            filteredMarkerObjects = [];

        $.each(records, function () {
            maps.markers[this.id].setMap(maps.map); // show markers from filtered records
            filteredMarkers.push(this.id);
            filteredMarkerObjects.push(maps.markers[this.id]);
        });
        $.each(maps.markers, function (key, value) {
            if (filteredMarkers.indexOf(key) === -1) {
                this.setMap(null); // hide markers excluded from filteredMarkers
            }
        });

        if (!maps.clusterer) {
            maps.clusterer = new MarkerClusterer(maps.map, filteredMarkerObjects, {imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m'});
        } else {
            maps.clusterer.clearMarkers();
            maps.clusterer.addMarkers(filteredMarkerObjects);
            maps.clusterer.redraw();
        }
    };

    /**
     * Get the current client's location.
     *
     * @param callback
     */
    var getClientLocation = function (callback) {
        if (!navigator.geolocation) {
            return; // navigator not supported
        }

        var clientLocation = JSON.parse(localStorage.getItem('clientLocation'));
        if (clientLocation) {
            callback(clientLocation); // position already determined
        } else {
            navigator.geolocation.getCurrentPosition(
                function (loc) { // success
                    var latLng = {
                        lat: loc.coords.latitude,
                        lng: loc.coords.longitude
                    };

                    localStorage.setItem('clientLocation', JSON.stringify(latLng));

                    callback(latLng);
                },
                function () { // error
                    localStorage.removeItem('clientLocation');
                }
            );
        }
    };

    return {
        init: init,
        initMap: initMap
    };

})(jQuery, window);
